import { fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import api from '../../utils/api';

export const initialState = fromJS({
  // KB Helpers
  kbHelpers: [],
  isKbHelpersLoading: false,
  // Full knowledge base
  kbLocaleLoaded: null,
  isKnowledgeBaseLoading: false,
  kbSections: [],
  isKnowledgeBaseSectionsLoading: false,
  kbSectionsContent: {},
});

// const
export const GET_KB_HELPERS = 'help/KB_HELPERS';
export const GET_KNOWLEDGE_BASE = 'help/GET_KNOWLEDGE_BASE';
export const PUT_KNOWLEDGE_BASE_SECTIONS = 'help/PUT_KNOWLEDGE_BASE_SECTIONS';
export const PUT_KNOWLEDGE_BASE_SECTION_CONTENT =
  'help/PUT_KNOWLEDGE_BASE_SECTION_CONTENT';
export const PUT_KNOWLEDGE_BASE_SECTION_CONTENTS_LOADED =
  'help/PUT_KNOWLEDGE_BASE_SECTION_CONTENTS_LOADED';
export const PUT_KNOWLEDGE_BASE_START_FETCH =
  'help/PUT_KNOWLEDGE_BASE_START_FETCH';
export const PUT_KNOWLEDGE_BASE_FINISH_FETCH =
  'help/PUT_KNOWLEDGE_BASE_FINISH_FETCH';

// action creators
export const getKnowledgeBaseHelpers = createAction(
  GET_KB_HELPERS,
  ({ currentLocale }) => ({
    promise: api.help.getKnowledgeBaseHelpers({ currentLocale }),
  }),
);

export const getKnowledgeBase = createAction(
  GET_KNOWLEDGE_BASE,
  (data) => data,
);
export const putKnowledgeBaseSections = createAction(
  PUT_KNOWLEDGE_BASE_SECTIONS,
);
export const putKnowledgeBaseSectionContent = createAction(
  PUT_KNOWLEDGE_BASE_SECTION_CONTENT,
);
export const putKnowledgeBaseSectionContentsLoaded = createAction(
  PUT_KNOWLEDGE_BASE_SECTION_CONTENTS_LOADED,
);
export const putKnowledgeBaseStartFetch = createAction(
  PUT_KNOWLEDGE_BASE_START_FETCH,
);
export const putKnowledgeBaseFinishFetch = createAction(
  PUT_KNOWLEDGE_BASE_FINISH_FETCH,
);

// reducer
const helpReducer = handleActions(
  {
    // KB Helpers
    [`${GET_KB_HELPERS}_REQUEST`]: (state) =>
      state.set('isKbHelpersLoading', true),

    [`${GET_KB_HELPERS}_SUCCESS`]: (state, { payload }) =>
      state
        .set('kbHelpers', payload.get('data'))
        .set('isKbHelpersLoading', false),

    [`${GET_KB_HELPERS}_ERROR`]: (state) =>
      state.set('isKbHelpersLoading', false),

    // Full knowledge base
    [`${PUT_KNOWLEDGE_BASE_START_FETCH}`]: (state) =>
      state
        .set('isKnowledgeBaseLoading', true)
        .set('isKnowledgeBaseSectionsLoading', true),

    [`${PUT_KNOWLEDGE_BASE_FINISH_FETCH}`]: (state) =>
      state
        .set('isKnowledgeBaseLoading', false)
        .set('isKnowledgeBaseSectionsLoading', false),

    [`${PUT_KNOWLEDGE_BASE_SECTIONS}`]: (
      state,
      { payload: { currentLocale, response } },
    ) =>
      state
        .set('kbLocaleLoaded', currentLocale)
        .set('kbSections', response.get('data'))
        .set('isKnowledgeBaseLoading', false),

    [`${PUT_KNOWLEDGE_BASE_SECTION_CONTENT}`]: (
      state,
      { payload: { code, response } },
    ) => state.setIn(['kbSectionsContent', code], response.get('data')),

    [`${PUT_KNOWLEDGE_BASE_SECTION_CONTENTS_LOADED}`]: (state) =>
      state.set('isKnowledgeBaseSectionsLoading', false),
  },
  initialState,
);

export default helpReducer;
